import React, { Fragment, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux";
import { loginAction, clearErrors, forgotPasswordAction } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import { FORGET_PASSWORD_RESET } from '../../../redux/constants/userConstant';
import Logo from "../../images/logo-black.png"


const Login = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { loading, error, message } = useSelector((state) => state.register);
  const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);

  const { loading: forgotLoading,
    error: forgotError,
    message: forgotMessage
  } = useSelector((state) => state.forgotPassword);


  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showFogotSection, setshowFogotSection] = useState(false)
  const [isSubmit, setIssubmit] = useState(false)
  const [isForgotSubmit, setisForgotSubmit] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);


  const handleSubmit = (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (!password) {
      toast.error("please Enter your Password")
      return
    }
    if (password.length < 8) {
      toast.error("Password should contain atleast 8 digits")
      return
    }

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    dispatch(loginAction(formData));

    setIssubmit(true)

  }



  useEffect(() => {
    if (message && isSubmit) {
      toast.success(message);
      localStorage.setItem("email", email);
      navigate('/verify-email');
      setIssubmit(false)
    }
    if (error) {
      toast.error(error);
      dispatch(clearErrors());
    }
    if (isAuthenticated) {
      navigate('/')
    }
  }, [error, message, navigate, dispatch, email, isAuthenticated, isSubmit]);








  const handleForgotSubmit = (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }


    const userData = {
      email: email,
    }

    dispatch(forgotPasswordAction(userData))

    setisForgotSubmit(true)
  }

  useEffect(() => {
    if (forgotError) {
      toast.error(forgotError)
      dispatch(clearErrors())
    }

    if (forgotMessage && isForgotSubmit) {
      toast.success(forgotMessage)
      navigate('/forgot-password')
      localStorage.setItem("email", email);
      dispatch({ type: FORGET_PASSWORD_RESET })
    }

    document.title = `LOGIN`;


  }, [forgotError, dispatch, forgotMessage, navigate, email, isForgotSubmit])




  useEffect(() => {
    document.title = 'LOGIN'
  }, [])

  const getPasswordStrength = (password) => {
      let score = 0;
      if (/[a-zA-Z]/.test(password)) score++;      // any alphabet
      if (/\d/.test(password)) score++;            // number
      if (/[A-Z]/.test(password)) score++;         // uppercase
      if (/[^A-Za-z0-9]/.test(password)) score++; // special char
      return score; // 0 → 4
  };





  return (
    <Fragment>
      {loading || forgotLoading ? <Loader /> :
        <>          <section className="relative min-h-[100vh] w-full flex bg-white font-jakarta overflow-x-hidden">
            
            {/* Left Side: Dark & Corporate (Hidden on mobile) */}
            <div className="hidden lg:flex lg:w-[45%] bg-zinc-900 p-[5vmax] flex-col justify-between relative">
              {/* Subtle noise or pattern could go here, but pure dark is very clean */}
              <div className="absolute inset-0 bg-[linear-gradient(to_bottom_right,rgba(255,255,255,0.05),transparent)] pointer-events-none"></div>
              
              <div className="relative z-10">
                {/* Use the logo with invert to make it white on dark background */}
                <img src={Logo} alt="Zonify Pro" className="w-[35%] invert" />
              </div>
              
              <div className="relative z-10">
                <span className="text-indigo-400 font-semibold uppercase text-sm tracking-widest mb-3 block">Enterprise Portal</span>
                <h2 className="text-[3.5vmax] font-bold text-white leading-none mb-[1.5vmax]">The standard in e-commerce operations.</h2>
                <p className="text-[1.1vmax] text-zinc-400 font-light max-w-[85%] leading-relaxed">
                  A fully integrated platform for managing orders, tracking commissions, and optimizing your business performance.
                </p>
              </div>
              
              <div className="relative z-10 text-zinc-500 text-[0.85vmax] flex items-center gap-4">
                <span>© 2026 Zonify Pro</span>
                <span className="w-1 h-1 bg-zinc-700 rounded-full"></span>
                <span>Privacy Policy</span>
                <span className="w-1 h-1 bg-zinc-700 rounded-full"></span>
                <span>Terms of Service</span>
              </div>
            </div>

            {/* Right Side: Login Form */}
            <div className="flex-1 min-w-0 w-full flex items-center justify-center p-6 lg:p-12 bg-white relative">
              
              <div className="w-[calc(100vw_-_3rem)] max-w-md sm:w-full" data-aos="fade-up" data-aos-duration="1000">
                
                {/* Logo for mobile only */}
                <div className="flex justify-center mb-8 lg:hidden">
                  <img src={Logo} alt="Zonify Pro" className="w-32" />
                </div>
                
                <div className="mb-8 text-center lg:text-left">
                  <h4 className="text-2xl lg:text-3xl font-bold text-zinc-900 mb-2">Sign in to your account</h4>
                  <p className="text-sm lg:text-base text-zinc-500">
                    Welcome back. Please enter your credentials.
                  </p>
                </div>

                <form className="flex flex-col w-full" onSubmit={handleSubmit}>
                  {/* Email */}
                  <div className="flex flex-col mb-5">
                    <label className="text-xs font-semibold text-zinc-700 mb-1.5 uppercase tracking-wider">Email</label>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full px-4 py-3 rounded-lg border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 outline-none text-sm lg:text-base text-zinc-800 placeholder-zinc-400 bg-white transition-all shadow-sm"
                      placeholder="you@company.com"
                    />
                  </div>

                  {/* Password */}
                  <div className="flex flex-col mb-5">
                    <div className="flex flex-wrap justify-between items-center gap-2 mb-1.5">
                      <label className="text-xs font-semibold text-zinc-700 uppercase tracking-wider">Password</label>
                      <button 
                        className="text-xs font-medium text-zinc-500 hover:text-zinc-900 transition-colors" 
                        type="button" 
                        onClick={() => setshowFogotSection(true)}
                      >
                        Forgot password?
                      </button>
                    </div>
                    <div className="relative">
                      <input
                        type={showPassword ? 'text' : 'password'}
                        value={password}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\s/g, "");
                          setPassword(value);
                        }}
                        onFocus={() => setIsPasswordFocused(true)}
                        onBlur={() => setIsPasswordFocused(false)}
                        className="w-full px-4 py-3 rounded-lg border border-zinc-200 focus:border-zinc-900 focus:ring-1 focus:ring-zinc-900 outline-none text-sm lg:text-base text-zinc-800 placeholder-zinc-400 bg-white transition-all shadow-sm"
                        placeholder="••••••••"
                      />
                      <button type="button"
                        className="absolute inset-y-0 right-0 pr-4 flex items-center text-zinc-400 hover:text-zinc-600 transition-colors"
                        onClick={() => setShowPassword(prev => !prev)}>
                        <i className={`fa-regular ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                      </button>
                    </div>

                    {/* Password Hint */}
                    {isPasswordFocused && (
                        <div className="flex justify-end gap-1.5 pt-2">
                            {[1, 2, 3, 4].map((level) => {
                                const strength = getPasswordStrength(password);
                                let bg = "bg-zinc-200"; // default
                                if (strength >= level) {
                                    if (strength === 1) bg = "bg-red-500";
                                    if (strength === 2) bg = "bg-orange-500";
                                    if (strength === 3) bg = "bg-yellow-500";
                                    if (strength === 4) bg = "bg-green-500";
                                }
                                return (
                                    <span
                                        key={level}
                                        className={`w-6 h-1 rounded-full transition-all duration-300 ${bg}`}
                                    />
                                );
                            })}
                        </div>
                    )}
                  </div>

                  <button
                    type="submit"
                    className={`w-full py-3 rounded-lg font-medium text-sm lg:text-base transition-all mt-2
                      ${(email === '' || password === '') ? 
                        'bg-zinc-100 text-zinc-400 cursor-not-allowed' : 
                        'bg-zinc-900 text-white hover:bg-zinc-800 shadow-sm hover:shadow-md'}`}
                    disabled={email === '' || password === ''}
                  >
                    Sign in
                  </button>

                  <div className="text-sm text-zinc-500 text-center mt-6">
                    Don't have an account?
                    &nbsp;
                    <Link to="/user-signup" className="font-medium text-zinc-900 hover:text-zinc-700 transition-colors underline underline-offset-4">
                      Sign up for free
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </section>

          {/* Forgot Password Modal */}
          <section className={`fixed inset-0 bg-zinc-900/50 backdrop-blur-sm z-[100] transition-opacity flex items-center justify-center p-[2vmax]`}
            style={{ display: `${showFogotSection ? "flex" : "none"}` }}>
            
            <div className="bg-white shadow-xl rounded-2xl w-[95%] sm:w-[450px] overflow-hidden relative" data-aos="scale-up" data-aos-duration="300">
              {/* Close Button */}
              <button className='absolute top-[1vmax] right-[1vmax] text-zinc-400 hover:text-zinc-600 transition-colors text-[2vmax] lg:text-[1.5vmax]' 
                onClick={() => setshowFogotSection(false)}
              >
                <i className="fa-solid fa-xmark"></i>
              </button>

              <div className="p-[2.5vmax]">
                <h4 className='font-bold text-[2.2vmax] lg:text-[1.5vmax] text-zinc-800 text-center mb-[0.5vmax]' >Forgot Password?</h4>
                <p className='text-[1.4vmax] lg:text-[0.9vmax] text-zinc-500 text-center mb-[2vmax]'>Enter your email address and we'll send you a link to reset your password.</p>
                
                <form className="flex flex-col" onSubmit={handleForgotSubmit}>
                  <div className='flex flex-col mb-[2vmax]'>
                    <label className='text-[1.4vmax] lg:text-[0.9vmax] font-semibold text-zinc-700 mb-1' >Email Address <span className='text-red-500'>*</span></label>
                    <input
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className='w-full px-[1.2vmax] py-[0.8vmax] rounded-xl border border-zinc-200 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 outline-none text-[1.4vmax] lg:text-[1vmax] text-zinc-800 placeholder-zinc-400 bg-zinc-50/50 transition-all'
                      placeholder='you@company.com'
                    />
                  </div>
                  <button 
                    type='submit' 
                    className={`w-full py-[0.8vmax] rounded-xl font-bold text-[1.6vmax] lg:text-[1vmax] transition-all
                      ${email === '' ? 
                        'bg-zinc-100 text-zinc-400 cursor-not-allowed' : 
                        'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-md hover:shadow-lg hover:opacity-95'}`}
                    disabled={email === ''}
                  >
                    Forgot Password
                  </button>
                </form>
              </div>
            </div>
          </section>
        </>
      }

    </Fragment >

  )
}

export default Login
